<template>
    <div>
        <div class="page-container">
            <md-app md-waterfall md-mode="overlap">
                <md-app-toolbar class="md-primary md-large">
                    <div class="md-toolbar-row">
                        <md-button
                            class="md-fab"
                            style="width: 70px; height: 70px"
                            @click="menuVisible = !menuVisible"
                        >
                            <md-icon>menu</md-icon>
                        </md-button>
                        <div class="md-toolbar-section-start">
                            <div style="padding: 10px; padding-top: 50px">
                                <span id="title">
                                    <slot name="title" @click="menuVisible = !menuVisible">
                                        {{ $t('Section to replace') }}
                                    </slot>
                                </span>
                                <br />
                                <span id="subtitle" class="md-medium-hide">
                                    <slot name="subtitle"></slot>
                                </span>
                            </div>
                        </div>
                        <div class="md-toolbar-section-end">
                            <div class="md-layout">
                                <div class="md-layout-item md-medium-size-100">
                                    <md-button
                                        class="md-button"
                                        style="color: #2ec6d5 !important"
                                        :href="get_help_url()"
                                        target="_blank"
                                    >
                                        {{ $t('USER MANUAL') }}
                                    </md-button>
                                </div>
                                <div class="md-layout-item md-medium-size-100">
                                    <a href="https://socib.es/" target="_blank">
                                        <img
                                            :src="
                                                $store.state.publicPath +
                                                'logos/logo_socib_' +
                                                $i18n.locale.toUpperCase() +
                                                '.png'
                                            "
                                            title="SOCIB"
                                            style="padding: 10px; max-height: 80px"
                                        />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </md-app-toolbar>

                <md-app-drawer :md-active.sync="menuVisible">
                    <md-toolbar class="md-transparent" md-elevation="0" style="font-size: 200%">
                        {{ $t('Menu') }}
                    </md-toolbar>
                    <div id="language">
                        <md-button
                            class="md-icon-button md-dense"
                            v-if="$i18n.locale != 'en'"
                            @click="$i18n.locale = 'en'"
                            >EN</md-button
                        >
                        <md-button
                            class="md-icon-button md-dense"
                            v-if="$i18n.locale != 'es'"
                            @click="$i18n.locale = 'es'"
                            >ES</md-button
                        >
                        <md-button
                            class="md-icon-button md-dense"
                            v-if="$i18n.locale != 'ca'"
                            @click="$i18n.locale = 'ca'"
                            >CA</md-button
                        >
                    </div>
                    <md-list @click="menuVisible = !menuVisible" class="menu">
                        <md-list-item>
                            <md-icon>home</md-icon>
                            <span class="md-list-item-text">
                                <router-link to="/home"> {{ $t('Home') }}</router-link>
                            </span>
                        </md-list-item>
                        <md-list-item>
                            <md-icon>map</md-icon>
                            <span class="md-list-item-text">
                                <router-link to="/mapview"> {{ $t('Stations map') }}</router-link>
                            </span>
                        </md-list-item>
                        <md-list-item>
                            <md-icon>camera</md-icon>
                            <span class="md-list-item-text">
                                <router-link to="/lastimages"> {{ $t('Last images') }}</router-link>
                            </span>
                        </md-list-item>
                        <md-list-item>
                            <md-icon>event_available</md-icon>
                            <span class="md-list-item-text">
                                <router-link to="/filtering">
                                    {{ $t('Historical data') }}</router-link
                                >
                            </span>
                        </md-list-item>
                        <md-list-item>
                            <md-icon>compare</md-icon>
                            <span class="md-list-item-text">
                                <router-link to="/compareimages">
                                    {{ $t('Compare images') }}</router-link
                                >
                            </span>
                        </md-list-item>
                        <md-list-item>
                            <md-icon>auto_graph</md-icon>
                            <span class="md-list-item-text">
                                <router-link to="/datafiltering">
                                    {{ $t('Data Discovery') }}</router-link
                                >
                            </span>
                        </md-list-item>

                        <md-list-item>
                            <md-icon>help</md-icon>
                            <span class="md-list-item-text">
                                <a :href="get_help_url()" target="_blank"> {{ $t('Help') }}</a>
                            </span>
                        </md-list-item>
                        <md-list-item>
                            <md-icon>feed</md-icon>
                            <span class="md-list-item-text">
                                <a :href="get_about_url()" target="_blank"> {{ $t('About us') }}</a>
                            </span>
                        </md-list-item>
                        <md-list-item>
                            <md-icon>copyright</md-icon>
                            <span class="md-list-item-text">
                                <router-link to="/termsofuse">
                                    {{ $t('Terms of use') }}</router-link
                                >
                            </span>
                        </md-list-item>
                    </md-list>
                </md-app-drawer>

                <md-app-content id="content">
                    <slot> </slot>
                </md-app-content>
            </md-app>
        </div>

        <div id="footer">
            <div class="md-layout md-alignment-top-right" style="padding-right: 30px">
                <div class="md-layout-item md-medium-size-100" style="padding: 0px">
                    <a
                        href="https://www.socib.es"
                        target="_blank"
                        style="margin-left: logo icts_transparente.png"
                    >
                        <img
                            :src="
                                $store.state.publicPath +
                                'logos/full_logo_socib_' +
                                $i18n.locale.toUpperCase() +
                                '.png'
                            "
                            title="ICTS SOCIB"
                            style="max-height: 100px"
                        />
                    </a>
                </div>
                <div class="md-layout-item md-size-50 md-medium-size-100" style="text-align: right">
                    &copy; 2022 ICTS SOCIB <br />{{ $t('Contact') }}: beachmonitoring@socib.es
                    <br />
                    {{
                        $t('Balearic Islands Coastal Observing and Forecasting System (ICTS SOCIB)')
                    }}
                    <br />
                    Parc Bit, Naorte Building, Block A, Floor 2, Door 3. 07121, Palma,
                    {{ $t('Spain') }} | {{ $t('Phone') }}:+34 971 43 99 98 | Email:
                    beachmonitoring@socib.es
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Layout',
    data: () => ({
        menuVisible: false
    }),
    methods: {
        get_help_url() {
            if (this.$i18n.locale == 'es') {
                return 'https://ayuda.beamon.socib.es/'
            }

            if (this.$i18n.locale == 'ca') {
                return 'https://ajuda.beamon.socib.es/'
            }

            if (this.$i18n.locale == 'en') {
                return 'https://help.beamon.socib.es/'
            }
        },
        get_about_url() {
            if (this.$i18n.locale == 'es') {
                return 'https://ayuda.beamon.socib.es/home/sobre-nosotros'
            }

            if (this.$i18n.locale == 'ca') {
                return 'https://ajuda.beamon.socib.es/home/sobre-nosaltres'
            }

            if (this.$i18n.locale == 'en') {
                return 'https://help.beamon.socib.es/home/about-us'
            }
        }
    }
}
</script>

<style>
.md-drawer {
    max-width: calc(100vw - 125px);
}

.menu a {
    color: #1f8d98 !important;
    font-size: 150%;
}
.menu .md-icon {
    color: #1f8d98 !important;
    font-size: 150%;
}

.md-toolbar {
    background-color: #132b3f !important;
    color: #1f8d98 !important;
    min-height: 100px !important;
}
#title {
    font-size: 110%;
    color: #1f8d98 !important;
}

#subtitle {
    font-size: 90%;
    color: #ffffff55 !important;
}

#footer {
    bottom: 0;
    z-index: 150;
    padding-top: 60px;
    padding-bottom: 50px;
    margin-top: -50px;
    background-color: #132b3f !important;
    color: #1f8d98 !important;
    width: 100%;
}

.md-app-toolbar {
    z-index: 1500;
}

#footer img {
    margin-left: 20px;
}
#language {
    float: right;
    color: #1f8d98 !important;
}

#language .md-button {
    color: #1f8d98 !important;
    padding: 0px !important;
    margin: 0px !important;
    min-width: 10px !important;
}

#content {
    padding-top: 30px !important;
    margin: 10px !important;
}
</style>
